<div id="preloader">
    <div class="bg-loader">
        <div id="loader"></div>
    </div>
</div>
